import { getPendingSentInvitations } from 'api/v3/access/clients';
import { useQuery } from 'react-query';
import { UserCacheKeys } from 'types/cacheKeys.types';

const useFetchAccessRequests = () => {
  return useQuery(
    [UserCacheKeys.UserAccessRequests],
    getPendingSentInvitations,
  );
};

export default useFetchAccessRequests;
